import { isMobile } from "react-device-detect";

const chatbotState = { drawerOpen: false };

export const setDrawerOpen = (isOpen) => {
  if (isOpen) {
    chatbotState.drawerOpen = true;
    manageChatbotVisibility();
  } else {
    setTimeout(() => {
      chatbotState.drawerOpen = false;
      manageChatbotVisibility();
    }, 200);
  }
};

const CHATBOT_CONFIG = {
  hiddenPaths: ["bus-cel", "lista-cel", "checkout", "confirmation"],
  selectors: [

    // WhatsApp
    ".chatbot-element"
  ],
  checkInterval: 1000
};

const shouldHideByCurrentPath = () => {
  const currentPath = window.location.pathname;
  return CHATBOT_CONFIG.hiddenPaths.some(path =>
    currentPath.includes(path)
  );
};

const findChatbotContainers = () => {
  const containers = [];
  
  for (const selector of CHATBOT_CONFIG.selectors) {
    const elements = document.querySelectorAll(selector);
    
    if (elements.length > 0) {
      elements.forEach(element => {
        let container;

        // WhatsApp
        if (selector === ".chatbot-element") {
          container = element;
        }
          
        if (container && !containers.includes(container)) {
          containers.push(container);
        }
      });
      
      if (containers.length > 0) break;
    }
  }
  
  return containers;
};

export const manageChatbotVisibility = (
  forceHide = false,
  forceShow = false
) => {
  let shouldHide = false;
  
  if (!isMobile) {
    shouldHide = chatbotState.drawerOpen || forceHide;
  } else {
    shouldHide = forceHide || (shouldHideByCurrentPath() && !forceShow);
  }
  
  const containers = findChatbotContainers();
  
  containers.forEach(container => {
    container.style.display = shouldHide ? "none" : "block";
  });
};

export const setupChatbotVisibilityCheck = (forceHide = false) => {
  manageChatbotVisibility(forceHide);
  
  return setInterval(() => {
    manageChatbotVisibility(forceHide);
  }, CHATBOT_CONFIG.checkInterval);
};